/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, EventEmitter, OnInit } from "@angular/core";
import { MerchantUserRoles, UserRoles } from "../../../../models";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { BsModalRef } from "ngx-bootstrap/modal";
import { MerchantUserService, NotificationService } from "../../../../services";
import { minSelected } from "../../../../validators/MPCustomValidator";
import { ActionModalComponent } from "../../../action-modal/action-modal.component";

@Component({
  selector: "app-add-edit-user",
  templateUrl: "./add-edit-user.component.html"
})
export class AddEditUserComponent extends ActionModalComponent implements OnInit {
  userRoleForm!: FormGroup;
  userRoles = UserRoles;
  merchantUser?: MerchantUserRoles;
  merchantId!: number;
  arrOfRoles: any = [];
  public event: EventEmitter<MerchantUserRoles> = new EventEmitter();

  constructor(
    bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private merchantUserService: MerchantUserService,
    private notificationService: NotificationService
  ) {
    super(bsModalRef);
  }

  ngOnInit(): void {
    this.userRoleForm = this.fb.group({
      practiceStaffId: [
        { value: this.merchantUser ? this.merchantUser.practicestaffId : "", disabled: this.isEdit() },
        [Validators.required, Validators.maxLength(12), Validators.pattern("^\\d*$")]
      ],
      userName: [this.merchantUser ? this.merchantUser.userName : "", [Validators.required, Validators.maxLength(99)]],
      merchantUserRoles: new FormArray([], minSelected(1))
    });
    Object.keys(this.userRoles).forEach((key) => {
      this.arrOfRoles.push({
        name: this.userRoles[key as keyof typeof UserRoles],
        value: key,
        checked: this.merchantUser ? this.merchantUser.roles.includes(key) : false
      });
    });
    this.addCheckboxes();
  }

  get userRoleControls() {
    return this.userRoleForm.controls;
  }

  get merchantUserRoles(): FormArray {
    return this.userRoleForm.get("merchantUserRoles") as FormArray;
  }

  private addCheckboxes() {
    this.arrOfRoles.forEach((x: any) => this.merchantUserRoles.push(new FormControl(x.checked)));
  }

  handleRoles(): void {
    if (this.userRoleForm.valid) {
      this.actionInProgress = true;
      const tempMerchantUser: any = {
        practicestaffId: this.userRoleControls.practiceStaffId.value,
        userName: this.userRoleControls.userName.value,
        roles: []
      };
      if (!this.isRemove()) {
        for (const role of this.arrOfRoles) {
          if (role.checked) {
            tempMerchantUser.roles.push(role.value);
          }
        }
      }

      this.merchantUserService.handleRoles(this.merchantId, tempMerchantUser as MerchantUserRoles).subscribe(
        (merchantUser) => {
          this.event.emit(merchantUser);
          this.actionInProgress = false;
          this.close();
        },
        (error) => {
          this.notificationService.error(error.error);
          this.actionInProgress = false;
        }
      );
    } else {
      this.userRoleForm.markAllAsTouched();
    }
  }

  updateRole(index: number) {
    this.arrOfRoles[index].checked = !this.arrOfRoles[index].checked;
  }
}
